const {KitModule, registerModule, modalManager} = window;

const SITE_HEADER_BLACK_CLASS_NAME = 'site-header--black';
const SEARCH_MODAL_KEY = 'searchModal';

// -------------------------- SearchModalButton -------------------------- //

class SearchModalButton extends KitModule {
  constructor($element) {
    super($element);
    this.$element.addEventListener('click', this);
  }

  onclick() {
    modalManager.toggle(SEARCH_MODAL_KEY);
  }
}

registerModule('SearchModalButton', SearchModalButton);

// -------------------------- SearchModal -------------------------- //

class SearchModal extends KitModule {
  constructor($element) {
    super($element);
    // elements
    this.$siteHeader = document.querySelector('.site-header');
    this.$input = this.$element.querySelector('[data-js-child="$input"]');
    // properties
    this.isOpen = false;
    this.isSiteHeaderBlack = this.$siteHeader.classList.contains(SITE_HEADER_BLACK_CLASS_NAME);

    this.$input.addEventListener('keyup', this.onInputKeyup.bind(this));
    document.body.addEventListener('keyup', this);

    modalManager.add({
      key: SEARCH_MODAL_KEY,
      open: () => this.open(),
      close: () => this.close(),
    });
  }

  // ------ events ------ //

  onInputKeyup(event) {
    // redirect to search page on Enter
    if (event.key === 'Enter' && this.$input.value) {
      const query = encodeURIComponent(this.$input.value);
      window.location = `/search/?q=${query}`;
    }
  }

  onkeyup(event) {
    if (event.key === 'Escape' && this.isOpen) {
      modalManager.close(SEARCH_MODAL_KEY);
    }
  }

  // ------ methods ------ //

  open() {
    if (this.isOpen) return;

    this.$element.classList.add('is-open');
    if (!this.isSiteHeaderBlack) this.$siteHeader.classList.add(SITE_HEADER_BLACK_CLASS_NAME);
    this.isOpen = true;
  }

  close() {
    if (!this.isOpen) return;

    this.$element.classList.remove('is-open');
    if (!this.isSiteHeaderBlack) this.$siteHeader.classList.remove(SITE_HEADER_BLACK_CLASS_NAME);
    this.isOpen = false;
  }
}


registerModule('SearchModal', SearchModal);
